import StopListItem from "./StopListItem";

export default function StopList({ stops }) {
  if (!stops) return null;

  return (
    <ul className="w-full pb-3">
      {stops.map((stop) => (
        <StopListItem
          key={stop.index}
          title={stop.location ? stop.location.title : ""}
          locationType={stop.location ? stop.location.type.value : null}
          slug={stop.slug}
          highlight={stop.highlight}
          index={stop.index}
          duration={stop.duration}
          calculatedPeriod={stop.calculatedPeriod}
          type={stop.stop_type.value}
          backgroundColor={stop.color}
        />
      ))}
    </ul>
  );
}
